import { ButtonComponentActionConfigVariant } from '@repo/sdk/models/components';

import { TooltipButton } from '@/components/molecules/tooltip-button';
import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';
import { cn } from '@/ux-common/lib/utils';

import { ActionComponentProps } from './types';
import { useHandleUpdateSettings } from './use-handle-update-settings';
import { mapLegacyButtonVariantToClassName } from '../utils';

export const ActionButton = ({ state, ...props }: ActionComponentProps) => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    // TODO: UX-3355: We probably need to specify permissions in the button config
    privilege: PRIVILEGES.writeCommands,
  });

  const { handleUpdateSettings, isPending: isUpdatingSettings } = useHandleUpdateSettings();

  const buttonConfig = state?.actionComponentConfig?.buttonComponentActionConfig;
  const buttonVariant = buttonConfig?.variant ?? ButtonComponentActionConfigVariant.Default;
  const disabledByConfig = buttonConfig?.disabled ?? false;
  const label = buttonConfig?.label ?? 'Button';

  const disabled = disabledByConfig || isUpdatingSettings || disabledByPermissions;
  const disabledMessage = buttonConfig?.disabledMessage ?? tooltipText;

  return (
    <TooltipButton
      {...props}
      data-state-name={state?.stateName}
      className={cn('text-wrap w-full', mapLegacyButtonVariantToClassName(buttonVariant))}
      disabled={disabled}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        handleUpdateSettings?.(buttonConfig?.actions?.settingActions || []);
      }}
      tooltipContent={disabled ? disabledMessage : undefined}
    >
      {label}
    </TooltipButton>
  );
};
